export const LineLayouts = [
  {value: '2_5x0_75', display: '2.5" x 0.75"'},
  {value: '3_5x1', display: '3.5" x 1"'},
  {value: '3_5x1_125', display: '3.5" x 1.125"'},
  {value: '4x3', display: '4" x 3"'},
  {value: '30up', display: '30-up'},
  {value: '10up', display: '10-up'},
  {value: '6up', display: '6-up'},
]

export const BarcodeTypeOptions = [
  {value: 'CODE128', display: 'Code128'},
  {value: 'QR', display: 'QR Code'},
]

export const OrderReferenceKeyOptions = [
  {value: 'reference_id', display: 'Order Number'},
  {value: 'barcode', display: 'Barcode'},
]
